export default __webpack_public_path__ + "static/media/BackIcon.082f0cc1.svg";